module.exports = __webpack_public_path__ + "img/na_hradzi_1.fefc8e3e.jpg";